angular.module('SpidApp')

.factory('YearStockLineChartGenerator', ['StockChartUtils', function (StockChartUtils) {
    var YearStockLineChartGenerator = function (stockflowsHistory) {
    	stockflowsHistory = stockflowsHistory || {}
    	
    	var series = []
    	var datas  = []
    	var colors = []
    	
        var startOfYear = moment()
        startOfYear.set('date', 1)
        startOfYear.set('month', 0)
        
        var endOfYear = moment()
        endOfYear.set('date', 31)
        endOfYear.set('month', 11)
        
        _.chain(stockflowsHistory).mapObject(function(stockflows, key) {
    		
    		series.push(stockflows[0].stockProduct.product.label);
    		colors.push(StockChartUtils.hashStringToColor(stockflows[0].stockProduct.product.label));
    		
    		var stockflowsOrderedByMonth = _.chain(stockflows).groupBy(function (stockflow) {
                return moment(stockflow.updated_at).format('MM/YYYY') // TODO: bad locale flow
            }).mapObject(function (stockflows) {
                var res = 0
                if (stockflows.length > 0) {
                    res = stockflows[0].current
                }
                return res
            }).value()
            
            var data = []
            var curseur = moment(startOfYear)
        
            var dataTmp = 0;
	        for(var i = 0 ; i < 12 ; i++) {
	            key = curseur.format('MM/YYYY')
	            
	            if (!stockflowsOrderedByMonth[key] && stockflowsOrderedByMonth[key] !== 0) {
            		data[i] = dataTmp
            	}
            	else {
            		data[i] = stockflowsOrderedByMonth[key]
            	}
            	dataTmp = data[i]
	            curseur.add(1, 'month')
	        }
	        datas.push(data)
    	})
        
        this.labels  = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
        this.series  = series
        this.datas	 = datas
        this.colours = colors
    }
        
    YearStockLineChartGenerator.prototype.get = function () {
        return {
              series     : this.series
            , labels     : this.labels
            , datas      : this.datas
            , colours	 : this.colours
        }
    }
    
    return YearStockLineChartGenerator
}])
